export default "__VITE_ASSET__C_tz_7aj__"